<template>
  <div>
    <crumbs v-if="!fromSpbo2">
        <i class="glyphicon glyphicon-cog"></i>
        <span class="text">{{commissionViewLan.title}}</span>
    </crumbs>
    <div class="principal-wrap">
      <el-button-group class="role-btn-group">
          <el-button  type="info" plain class="role" :class="{'curRole': (active == '/ib_v2')}" @click="jump('/ibPrimary_v2')">{{commissionViewLan.role.ib}}</el-button>
          <el-button  type="info" plain class="role" :class="{'curRole': (active == '/sale_v2')}" @click="jump('/salePrimary_v2')">{{commissionViewLan.role.sale}}</el-button>
      </el-button-group>
      <router-view :status="status"></router-view>
    </div>
  </div>
</template>

<script>
import crumbs from "components/crumbs"
export default {
  name: 'commissionView_v2',
  created() {
    if (this.role && this.region) {
        this.role == 'ib' ? this.jump('/ibPrimary_v2/?status='+this.status+'&region='+this.region) : this.jump('/salePrimary_v2/?status='+this.status+'&region='+this.region)

        let currentArea = JSON.parse(sessionStorage.currentArea20)
         currentArea.value = this.region
         sessionStorage.currentArea20 = JSON.stringify(currentArea)
      }
  },
  beforeCreate() {
    const areaObj = JSON.parse(sessionStorage.area20);
    const profitshare_area = JSON.parse(sessionStorage.profitshare_area);
    const storage = sessionStorage.currentArea20 || "{}";
    let currentArea = JSON.parse(storage);
    currentArea.group = profitshare_area[0];
    currentArea.value = areaObj[0];
    sessionStorage.currentArea20 = JSON.stringify(currentArea);
  },
  mixins: [
    require("common/mixin/base.js").base({commissionViewLan:"commissionView"}),
  ],
  data () {
    return {
      role: this.$route.query.role ? this.$route.query.role.split('$')[0] : '',
      region: this.$route.query.role ? this.$route.query.role.split('$')[1] : '',
      status: this.$route.query.role ? this.$route.query.role.split('$')[2] : '',
      act: '',
      fromSpbo2:sessionStorage.fromSpbo2
    }
  },
  computed: {
      active () {
        //   return this.$route.path.slice(this.$route.path.indexOf('/',1),this.$route.path.lastIndexOf('/'))
        return this.$route.path.slice(this.$route.path.indexOf('/'),this.$route.path.lastIndexOf('/'))
      }
  },
  components: {
    crumbs
  },
  methods:{
    jump (link) {
    //   this.$router.push({path: this.path + link})
    this.$router.push(link)
    //   this.active = link
      this.act = link
    },
  }
}
</script>

<style lang="scss" scoped>
  .principal-wrap{
        margin: 20px;
        background: #fff;
        .role-btn-group{
            width: 100%;
            margin-bottom: 20px;
            .curRole{
                background: #3F51B5;
                color: #fff;
            }
            .role{
                width: 50%;
                font-size: 18px;
            }
        }
    }
</style>





// WEBPACK FOOTER //
// commissionView.vue?69f6c218